"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DummyWindow_1 = require("../model/DummyWindow");

var DummyWindowConverter_1 = require("./DummyWindowConverter");
/**
 * Default implementation of DummyWindowConverter.
 *
 * @author ZSr
 */


var DummyWindowConverterImpl =
/*#__PURE__*/
function (_DummyWindowConverter) {
  _inherits(DummyWindowConverterImpl, _DummyWindowConverter);

  function DummyWindowConverterImpl() {
    _classCallCheck(this, DummyWindowConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowConverterImpl).apply(this, arguments));
  }

  _createClass(DummyWindowConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new DummyWindow_1.DummyWindow(DummyWindow_1.DummyWindow.schema.id.valueOf(conversions.documentToClassId(source)), DummyWindow_1.DummyWindow.schema.windowName.valueOfField(source), DummyWindow_1.DummyWindow.schema.articleName.valueOfField(source), DummyWindow_1.DummyWindow.schema.productId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        windowName: source.windowName,
        articleName: source.articleName,
        productId: source.productId
      });
      return result;
    }
  }]);

  return DummyWindowConverterImpl;
}(DummyWindowConverter_1.DummyWindowConverter);

exports.DummyWindowConverterImpl = DummyWindowConverterImpl;